import * as THREE from 'three'
let sin = (v) => Math.sin(v)
let cos = (v) => Math.cos(v)
let acos = (v) => Math.acos(v)
let tan = (v) => Math.tan(v)
let floor = (v) => Math.floor(v)
let pi = Math.PI
// value, index, total amount, fraction
let modes = [
    {
        rotation: {
            x: (v, i, a, f) => 0,
            y: (v, i, a, f) => sin(f * pi * 2),
            z: (v, i, a, f) => cos((f * pi * 2)) + cos(v + f * pi * 2),
        },
        position: {
            x: (v, i, a, f) => sin((v / 10) + (f * pi * 2)) * (2 + 1 * 1.4),
            y: (v, i, a, f) => cos((v / 10) + (f * pi * 2)) * (2 + 1 * 1.4),
            z: (v, i, a, f) => 0
        },
        scale: (v, i, a, f) => 0.9
    },
    {
        rotation: {
            x: (v, i, a, f) => 0,
            y: (v, i, a, f) => pi,
            z: (v, i, a, f) => (((f * pi * 4) + Math.sin(v / 10) * 5))
        },
        position: {
            x: (v, i, a, f) => sin((v / 10) + (f * pi * 2)) * (2 + 1 * 1.4),
            y: (v, i, a, f) => cos((v / 10) + (f * pi * 2)) * (1 * 1.4) +1,
            z: (v, i, a, f) => cos((v / 10) + (f * pi * 2)) * (2 + 1 * 1.4)
        },
        scale: (v, i, a, f) => sin((v / 10) + (f * pi * 3)) * (1 * 0.5) + 0.3
    },
    {
        rotation: {
            x: (v, i, a, f) => 0,
            y: (v, i, a, f) => pi,
            z: (v, i, a, f) => (((f * pi * 2) + Math.cos(v / 10) * 5))
        },
        position: {
            x: (v, i, a, f) => sin((v / 10) + (f * pi * 1.66)) * (2 + 1 * 1.4),
            y: (v, i, a, f) => cos((v / 10) + (f * pi * 1.66)) * (2 + 1 * 1.4),
            z: (v, i, a, f) => 0
        },
        scale: (v, i, a, f) => (((f * pi) * 2))*0.15
    },
    {
        rotation: {
            x: (v, i, a, f) => 0,
            y: (v, i, a, f) => (((f * pi * 4) + Math.sin(v / 10) * 5)) + pi,
            z: (v, i, a, f) => 0
        },
        position: {
            x: (v, i, a, f) => cos((v / 4) + (f * pi * 2)) * (2 + 1 * 0.4),
            y: (v, i, a, f) => sin((v / 4) + (f * pi * 2)) * (2 + 1 * 0.4),
            z: (v, i, a, f) => sin((v *2) + (f * pi * 8)) * (2 * 0.4)
        },
        scale: (v, i, a, f) => 0.75
    },
    {
        rotation: {
            x: (v, i, a, f) => 0,
            y: (v, i, a, f) => cos(f * pi * 4),
            z: (v, i, a, f) => (((f * pi * 2) + Math.sin(v / 4) * 5))
        },
        position: {
            x: (v, i, a, f) => cos(f * pi * 2) * 1 * 3,
            y: (v, i, a, f) => sin(f * pi * 2) * 1 * 3,
            z: (v, i, a, f) => 0
        },
        scale: (v, i, a, f) => 0.5
    },
    {
        rotation: {
            x: (v, i, a, f) => sin(i + v / 20) * pi * 2,
            y: (v, i, a, f) => sin((i / (a))) * pi * 2,
            z: (v, i, a, f) => 0,
        },
        position: {
            x: (v, i, a, f) => sin((i / (a) * pi * 2)) * (3 + 0.4 * 2),
            y: (v, i, a, f) => cos((i / (a) * pi * 2)) * (3 + 0.4 * 2),
            z: (v, i, a, f) => 0
        },
        scale: (v, i, a, f) => 0.5
    },
    {
        rotation: {
            x: (v, i, a, f) => 0,
            y: (v, i, a, f) => pi,
            z: (v, i, a, f) => (((f * pi * 1.5) + Math.sin(v / 10) * 5))
        },
        position: {
            x: (v, i, a, f) => sin((v / 2.5) + (f * pi )) * (2 + 1 * 1.4),
            y: (v, i, a, f) => cos((v / 1) + (f * pi )) * (2 + 1 * 1.1),
            z: (v, i, a, f) => 0
        },
        scale: (v, i, a, f) => (((f * pi * 2)))*0.16
    }
]
export default modes